import axios from "axios";
import { API } from "./client";

export async function getAutomations() {
  const res = await axios.get(`${API}/automations`);
  return res.data;
}

export async function createAutomation(payload) {
  const res = await axios.post(`${API}/automations`, payload);
  return res.data;
}

export async function updateAutomation(id, payload) {
  const res = await axios.put(`${API}/automations/${id}`, payload);
  return res.data;
}

export async function toggleAutomation(id) {
  const res = await axios.patch(`${API}/automations/${id}/toggle`);
  return res.data;
}

export async function deleteAutomation(id) {
  const res = await axios.delete(`${API}/automations/${id}`);
  return res.data;
}

export async function initiateConnectorAuth({ connector_type, redirect_url }) {
  const res = await axios.post(`${API}/automations/connectors/initiate`, {
    connector_type,
    redirect_url,
  });
  return res.data;
}

export async function getConnectorStatus() {
  const res = await axios.get(`${API}/automations/connectors/status`);
  return res.data;
}

export async function disconnectConnector(connector) {
  const res = await axios.delete(`${API}/automations/connectors/${connector}`);
  return res.data;
}
